export default __webpack_public_path__ + "static/media/berkeleylab.2121677d.svg";